module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Custom Invoice For Billing")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    staticClass: "ml-1",
    staticStyle: {
      "font-size": "0.675rem",
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.proceedAssignmentProforma(
          _vm.ffInvoiceModal.allModuleId,
          0,
          _vm.ffInvoiceModal.jobNo
        )
      }
    }
  }, [_vm._v("Proceed To Proforma")])], 1)], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.allData[0].allModuleId ? this.allData[0].allModuleId : '',
      "jobSeriesBanner": this.allData[0].ccImportSeries ? this.allData[0].ccImportSeries : '',
      "bannerClientName": this.allData[0].clientName ? this.allData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(_vm.sentForApproval == '1' && _vm.chnageApprovalStatus != '1') ? _c('h4', {
    staticClass: "mt-3 error"
  }, [_vm._v("\n              Invoice Sent For Approval\n            ")]) : _vm._e(), _vm._v(" "), (_vm.PreviousPerformaList.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body row"
  }, _vm._l((_vm.PreviousPerformaList), function(pre_item, pre_index) {
    return _c('div', {
      key: pre_index,
      staticClass: "col-md-2"
    }, [(pre_item.profarmaSeries) ? _c('b-button', {
      staticClass: "mt-2",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": "info"
      },
      on: {
        "click": function($event) {
          _vm.getPreviousTallyData(pre_item)
        }
      }
    }, [_c('b', [_vm._v(_vm._s(pre_item.profarmaSeries))])]) : _vm._e()], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Job No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.jobNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "jobNo", $$v)
      },
      expression: "ffInvoiceModal.jobNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "containerTypeId"
    }
  }, [_vm._v("Invoice Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.ffInvoiceModal.invoiceStatus),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "invoiceStatus", $$v)
      },
      expression: "ffInvoiceModal.invoiceStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.clientName),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "clientName", $$v)
      },
      expression: "ffInvoiceModal.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("CFS Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllLocDDList'],
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select CFS Name"
    },
    model: {
      value: (_vm.ffInvoiceModal.fk_cfs_loc_id),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "fk_cfs_loc_id", $$v)
      },
      expression: "ffInvoiceModal.fk_cfs_loc_id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Client Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.adress),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "adress", $$v)
      },
      expression: "ffInvoiceModal.adress"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place Of Receipt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POR),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POR", $$v)
      },
      expression: "ffInvoiceModal.POR"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Load Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.LP),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "LP", $$v)
      },
      expression: "ffInvoiceModal.LP"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port Of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.POD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "POD", $$v)
      },
      expression: "ffInvoiceModal.POD"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "FPOD", $$v)
      },
      expression: "ffInvoiceModal.FPOD"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.newContainerFlow == '0') ? _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Bill No/ Date(MM/DD/YY)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.BOE),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "BOE", $$v)
      },
      expression: "ffInvoiceModal.BOE"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.newContainerFlow == '0') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("BL No")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.blNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "blNo", $$v)
      },
      expression: "ffInvoiceModal.blNo"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.newContainerFlow == '0') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvNo),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvNo", $$v)
      },
      expression: "ffInvoiceModal.shipperInvNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Invoice Date(MM/DD/YY)")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.ffInvoiceModal.shipperInvDate),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shipperInvDate", $$v)
      },
      expression: "ffInvoiceModal.shipperInvDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voy")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.vessel),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "vessel", $$v)
      },
      expression: "ffInvoiceModal.vessel"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Weight (KGS)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.weight),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "weight", $$v)
      },
      expression: "ffInvoiceModal.weight"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientName",
      "name": "clientName"
    },
    model: {
      value: (_vm.ffInvoiceModal.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.ffInvoiceModal, "shippingLine", $$v)
      },
      expression: "ffInvoiceModal.shippingLine"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1)]), _vm._v(" "), (_vm.newContainerFlow == '1') ? _c('div', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container No")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Container Type")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shipper Inv.")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Shipping Bill")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Weight")])]), _vm._v(" "), _vm._l((_vm.allNewContainers), function(itm, idx) {
    return _c('tr', {
      key: idx
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.containerType))]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(itm.shipperInvoiceNo) + "\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(itm.shipperInvoiceDate) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(itm.shippingBillNo) + "\n                      "), _c('br'), _vm._v("\n                      " + _vm._s(itm.shippingBillDate) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(itm.grossWeight) + " " + _vm._s(itm.weightUnit))])])
  })], 2)])]) : _c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, _vm._l((_vm.ffInvoiceModal.containerDetails), function(item, index) {
    return _c('b-form-input', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo",
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, _vm._l((_vm.ffInvoiceModal.multipleContainerType), function(item1, index) {
    return _c('b-form-input', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": "",
        "id": "clientRegistrationNo",
        "name": "clientRegistrationNo",
        "value": item1
      }
    })
  }))], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Profit-Loss', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName,
      "PLAccordianStatus": false,
      "PLAccordianButton": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.ffInvoiceModal.allModuleId)
    }
  }), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('Payment-Summary', {
    attrs: {
      "PMS_fk_all_module_id": _vm.ffInvoiceModal.allModuleId,
      "PMS_jb_series": _vm.ffInvoiceModal.jobNo,
      "PMS_fk_client_id": _vm.ffInvoiceModal.clientName
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('span', {
    staticClass: "error mt-4"
  }, [_vm._v("\n                  Note : Approval will be required when Selling Rate is less than\n                  Quotation Rate.!\n                ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "error mt-1"
  }, [_vm._v("* marked heads are mandatory..!")])]), _vm._v(" "), _c('table', {
    staticClass: "table mt-3 table-light table-bordered",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [(_vm.chnageApprovalStatus != '1') ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "size": "sm"
    },
    on: {
      "click": _vm.addQuotationFields
    }
  }, [_c('md-icon', [_vm._v("add")])], 1) : _vm._e()], 1), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "170px"
    }
  }, [_vm._v("Particulars*")]), _vm._v(" "), _c('th', [_vm._v("Container Type*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "82px"
    }
  }, [_vm._v("Quantity*")]), _vm._v(" "), _c('th', [_vm._v("Currency*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v("Quotation Rate")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v("Selling Rate*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Exch Rate*")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v("Invoice Amount(Without Taxes)*")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ffTallyInvoiceData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeCol(index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove")])], 1)], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "list": _vm.$store.getters['common/getAllLedgerList'],
        "option-value": "ledger",
        "option-text": "ledger",
        "placeholder": "Select Particular"
      },
      model: {
        value: (item.ccType),
        callback: function($$v) {
          _vm.$set(item, "ccType", $$v)
        },
        expression: "item.ccType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "list": _vm.containerMasterData,
        "option-value": "containerType",
        "option-text": "containerType",
        "placeholder": "Select Type"
      },
      model: {
        value: (item.containerType),
        callback: function($$v) {
          _vm.$set(item, "containerType", $$v)
        },
        expression: "item.containerType"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.quantity),
        callback: function($$v) {
          _vm.$set(item, "quantity", $$v)
        },
        expression: "item.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "list": _vm.currencyList,
        "option-value": "currencyV",
        "option-text": "currencyT",
        "placeholder": "Select"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "disabled": item.ccSellingRate ? true : false
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.ccSellingRate),
        callback: function($$v) {
          _vm.$set(item, "ccSellingRate", $$v)
        },
        expression: "item.ccSellingRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.sellingRateFinal),
        callback: function($$v) {
          _vm.$set(item, "sellingRateFinal", $$v)
        },
        expression: "item.sellingRateFinal"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "type": "number"
      },
      on: {
        "input": function($event) {
          _vm.getFinalAmount(index)
        }
      },
      model: {
        value: (item.exchRate),
        callback: function($$v) {
          _vm.$set(item, "exchRate", $$v)
        },
        expression: "item.exchRate"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.chnageApprovalStatus == '1' ? true : false
      },
      model: {
        value: (item.invAmount),
        callback: function($$v) {
          _vm.$set(item, "invAmount", $$v)
        },
        expression: "item.invAmount"
      }
    })], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.chnageApprovalStatus == '1' ? true : false,
        "list": _vm.unitList,
        "option-value": "unitId",
        "option-text": "unitName",
        "placeholder": "Select"
      },
      model: {
        value: (item.unit),
        callback: function($$v) {
          _vm.$set(item, "unit", $$v)
        },
        expression: "item.unit"
      }
    })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    })], 1)])
  }))]), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId && _vm.is_noe_validation) ? _c('ExpenseTableComponent', {
    ref: "expenseTableComponent",
    attrs: {
      "show-debug": false,
      "initial-expenses": _vm.initialExpenses,
      "enable-validation": true,
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "jobNo": _vm.ffInvoiceModal.jobNo,
      "moduleType": 'CC',
      "transportType": 'Export',
      "branchId": _vm.$sessionsStorage.get('branch_baseLocation'),
      "invoiceStatus": _vm.ffInvoiceModal.invoiceStatus
    },
    on: {
      "expenses-saved": _vm.handleExpensesSaved,
      "expense-validation": _vm.handleExpenseValidation
    }
  }) : _vm._e(), _vm._v(" "), (_vm.ffInvoiceModal.allModuleId) ? _c('OldExpenseAdditionalTask', {
    attrs: {
      "allModuleId": _vm.ffInvoiceModal.allModuleId,
      "type": 'additional-task'
    }
  }) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [(_vm.validateTally == false && this.sentForApproval != '1') ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": (_vm.DisableSubmit == '0' || _vm.validSubmit == false) &&
        _vm.$store.getters['common/getAllSuccessInvoiceTB']
        .InvoiceTypeKeyFlag == true ?
        true :
        false,
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('1')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.ffInvoiceModal.invoiceStatus == "0" ?
    "Save & Send To Billing" :
    "Save & Submit") + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.updateTime != 'null' && _vm.editUserName != 'null') ? _c('span', {
    staticStyle: {
      "mmargin-top": "auto",
      "margin-bottom": "auto",
      "padding-top": "20px",
      "margin-left": "20px"
    }
  }, [_vm._v("\n                  Last Updated At :\n                  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.updateTime))]), _vm._v(" , By :\n                  "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.editUserName))]), _c('br'), _vm._v(" "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .BillingSeriesDataString
  ) ? _c('div', [_vm._v("\n                    Invoice No.\n                    "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.$store.getters["common/getAllSuccessInvoiceTB"]
    .BillingSeriesDataString))]), _vm._v("\n                    genrated.\n                    "), (
    _vm.$store.getters['common/getAllSuccessInvoiceTB']
    .InvoiceTypeKeyFlag == true
  ) ? _c('span', [_vm._v("Cannot be re-submitted")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [(_vm.validateTally == true && this.sentForApproval != '1') ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "disabled": _vm.DisableSubmit == '0' ? true : false,
      "variant": "dark"
    },
    on: {
      "click": function($event) {
        _vm.submitInvoice('2')
      }
    }
  }, [_vm._v("Send For Approval")]) : _vm._e()], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopMaxPer",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48347af4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/CCInvoiceForTallyExport.vue
// module id = 2586
// module chunks = 0